<era-security-list-group-items-ui [groups]="userGroups()"
                                  [isEditing]="isEditing()"
                                  (deleteEvent)="delete($event)"></era-security-list-group-items-ui>